module.exports = __webpack_public_path__ + "img/bugoro_08.37bafe6a.png";